// extracted by mini-css-extract-plugin
export default {"body":"userLeaveConfirmation_body__kKqbD"};